export { FinishSetupCta } from './finish-setup-cta.component';
